export default __webpack_public_path__ + "static/media/Q12_2_resized.294a1ae4.jpg";